import { Capacitor } from '@capacitor/core';
import { TextToSpeech } from '@capacitor-community/text-to-speech';

export const speakText = async (text) => {
  if (Capacitor.isNativePlatform()) {
    try {
      await TextToSpeech.speak({
        text,
        lang: 'en-US',
        rate: 1.0,
        pitch: 1.0,
        volume: 1.0,
      });
    } catch (error) {
      console.error('TextToSpeech failed:', error);
    }
  } else if ('speechSynthesis' in window && 'SpeechSynthesisUtterance' in window) {
    const utterance = new SpeechSynthesisUtterance(text);
    window.speechSynthesis.speak(utterance);
  } else {
    console.warn('Speech synthesis not supported on this platform.');
  }
};

export const stopSpeaking = async () => {
  if (Capacitor.isNativePlatform()) {
    try {
      await TextToSpeech.stop();
    } catch (error) {
      console.error('TextToSpeech stop failed:', error);
    }
  } else if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
  }
};
